<template>
  <div class="link-to-top-container">
    <TextLink @click="onClickToTopLink">
      gifteeトップへ戻る
    </TextLink>
    <form name="deleteBulkOrderForm" method="post" action="/bulk_order">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <input
        type="hidden"
        name="bulk_order_delete_form[referrer_url]"
        value=""
      />
      <input type="hidden" name="_method" value="DELETE" />
    </form>
    <TextModalWithSecondary
      v-if="showModal"
      :title-text="
        `トップページへ戻ると\n作成中のギフトカードリストは\n破棄されます`
      "
      primary-button-text="ギフトカード作成を続ける"
      secondary-button-text="gifteeトップへ戻る"
      :secondary-button-disabled="disabledGifteeTopButton"
      @clicked-modal-cover="closeBackToGifteeTopModal"
      @clicked-primary="onClickContinueGiftCardCreation"
      @clicked-secondary="onClickBackToGifteeTop"
    />
  </div>
</template>

<script setup>
import TextModalWithSecondary from '../../../components/molecules/modals/with_secondary/text-modal-with-secondary.vue'
import TextLink from '~/src/js/customer/components/atoms/text_links/TextLink.vue'
import { ref } from 'vue'
import { useBulkPersonalOrderSessionGiftCardStore } from '~/src/js/customer/store/bulkPersonalOrderSessionGiftCard'
import { useBulkPersonalOrderOrdererDetailStore } from '~/src/js/customer/store/bulkPersonalOrderOrdererDetailStore'

const csrfToken = ref(
  document.querySelector('meta[name="csrf-token"]').getAttribute('content')
)
const showModal = ref(false)
const disabledGifteeTopButton = ref(false)
const giftCardStore = useBulkPersonalOrderSessionGiftCardStore()
const ordererDetailStore = useBulkPersonalOrderOrdererDetailStore()

const onClickToTopLink = () => {
  showModal.value = true
}
const closeBackToGifteeTopModal = () => {
  showModal.value = false
}
const onClickContinueGiftCardCreation = () => {
  showModal.value = false
}
const onClickBackToGifteeTop = () => {
  disabledGifteeTopButton.value = true
  giftCardStore.$reset()
  ordererDetailStore.$reset()
  document.deleteBulkOrderForm.submit()
}
</script>
